<template>
  <div class="pointer-events-none bg-green-300 absolute inset-0 flex items-center justify-center">
    <span class="text-white font-bold">
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
    props: {
        text: { type: String, required: true },
    },
}
</script>